// extracted by mini-css-extract-plugin
export default {"wrapper":"D8Dq9D","text":"QDJpvo"};